import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  cursor: pointer;

  svg.fa-comments {
    font-size: 1.9em;
    position: relative;
    top: -1px;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const Dot = styled.span`
  position: absolute;
  right: -2px;
  top: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #79D9D9;
`;
